import { useEffect, useState } from "react";
import axios from "axios";

// Fetches every ConversationProgress row (the backend only supports
// filtering by conversation/student/isForMe/limit - nothing useful for an
// admin search screen) plus the conversation-type lookup for the filter bar.
export default function useConversationProgressList() {
    const [progresses, setProgresses] = useState([]);
    const [conversationTypes, setConversationTypes] = useState([]);

    useEffect(() => {
        axios
            .get("/api/conversationprogress", { withCredentials: true })
            .then((response) => setProgresses(response.data))
            .catch((err) => console.error(err));
        axios
            .get("/api/conversationtypes", { withCredentials: true })
            .then((response) => setConversationTypes(response.data))
            .catch((err) => console.error(err));
    }, []);

    return { progresses, conversationTypes };
}
